import { Button } from "@dropbox/dig-components/buttons";
import { UIIcon } from "@dropbox/dig-icons";
import { ChevronLeftLine } from "@dropbox/dig-icons/assets";
import i18n from "@mirage/translations";
import { RoutePath } from "@mirage/webapp/routeTypes";
import { useAtomValue } from "jotai";
import { NavLink } from "react-router-dom";
import { activeStackAtom } from "../ActiveStack/atoms";
import { ManageStackMenu } from "./ManageStackMenu";
import { PinStackButton } from "./PinStackButton";
import styles from "./StackNavBar.module.css";

import type { users } from "@dropbox/api-v2-client/types";
import type { MenuPlacement } from "@dropbox/dig-components/menu";
import type { SetMenuOpenForStackId } from "../ActionsMenu";

export const StackNavBar = ({
  mutationRequestId,
  sessionId,
  currentAccount,
  iconColor,
  setMenuOpenForStackId,
  menuPlacement,
}: {
  mutationRequestId?: string;
  sessionId?: string;
  currentAccount: users.FullAccount;
  iconColor?: string;
  setMenuOpenForStackId?: SetMenuOpenForStackId;
  menuPlacement?: MenuPlacement;
}) => {
  const stack = useAtomValue(activeStackAtom);

  return (
    <div className={styles.stackNavBar}>
      <div className={styles.stackNavBarLeft}>
        <NavLink to={RoutePath.STACKS}>
          <Button
            variant="borderless"
            withIconStart={<UIIcon src={ChevronLeftLine} />}
          >
            {i18n.t("all_stacks")}
          </Button>
        </NavLink>
      </div>
      {stack && (
        <div className={styles.stackNavBarRight}>
          <PinStackButton
            stack={stack}
            mutationRequestId={mutationRequestId}
            sessionId={sessionId}
            currentAccount={currentAccount}
            iconColor={iconColor}
          />
          <ManageStackMenu
            stack={stack}
            iconType="gear"
            currentAccount={currentAccount}
            setMenuOpenForStackId={setMenuOpenForStackId}
            iconColor={iconColor}
            menuPlacement={menuPlacement}
          />
        </div>
      )}
    </div>
  );
};
